import React from 'react';

const TextEditorViewer = (props) => {
    return (
        <div className="ck-content">
            <div className="body" dangerouslySetInnerHTML={{ __html: props.data }}></div>
        </div>
    );
};

export default TextEditorViewer;
